import { GtmEventAction } from "@obg/gtm.types/adaptive";

export const EVENTS_WITH_PRODUCT_THEME = [GtmEventAction.GenericButtonClick, GtmEventAction.VirtualPageView];
